// extracted by mini-css-extract-plugin
module.exports = {"categoryPill":"product-ui-category-pill_categoryPill__AtF_e","primary":"product-ui-category-pill_primary__w75N1","outline":"product-ui-category-pill_outline__64ckS"};